import protectedRoute from './protectedRoute';

export default protectedRoute;
